export const LINKEDIN_FLOW_STORAGE_KEY = 'linkedinAuthFlow';
